<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div class="page-container" v-else>
    <div class="header">
      <div class="header-left">
        <img src="/assets/color-logo.svg" alt="CoreEvent logo" class="coreEvent-logo" />
        <span>CoreEvent d.o.o</span>
        <span>Dunjevac 15, 10000 Zagreb, HR</span>
      </div>
      <div class="header-right">
        <span>Mail: <a href="mailto:contact@core-event.co">contact@core-event.co</a></span>
        <span>OIB: 36611335369</span>
        <span>IBAN: HR7523400091511211058</span>
        <span>Privredna banka Zagreb d.d., Radnička cesta 50, Zagreb</span>
      </div>
    </div>
    <div style="width: 200px; display: flex; flex-direction: column">
      <div style="display: flex; justify-content: space-between">
        <span><b>Zagreb, dana</b></span> <span> {{ todayDate }}</span>
      </div>
      <div style="display: flex; justify-content: space-between">
        <span><b>Datum valute</b></span> <span> {{ todayDate }}</span>
      </div>
    </div>
    <div class="user-informations-container">
      <div class="user-info-container">
        <div class="user-title">VJEROVNIK</div>
        <div class="user-informations">
          <p><b>CoreEvent d.o.o.</b></p>
          <div style="display: flex; flex-direction: column">
            <span><b>OIB: 36611335369</b></span>
            <span>IBAN: HR5223400091111141277</span>
            <span>Adresa: Dunjevac 15, 10000 Zagreb, HR</span>
          </div>
        </div>
      </div>
      <div class="user-info-container">
        <div class="user-title">DUŽNIK</div>
        <div class="user-informations">
          <p>
            <b>IME DUŽNIKA</b>
          </p>
          <div style="display: flex; flex-direction: column">
            <span>
              <b>OIB: -</b>
            </span>
            <span>IBAN: -</span>
            <span>Adresa: -</span>
          </div>
        </div>
      </div>
    </div>
    <h1 style="border-bottom: 3px solid black; text-align: center">
      Izjava o kompenzacija K-{{ reportId }}/{{ getYear(new Date()) }}
    </h1>
    <p>
      - U razdoblju od {{ formatDate(firstDayOfPrevMonth) }} -
      {{ formatDate(lastDayOfPrevMonth) }} ste prodali ulaznice po obračunu {{ reportId }}/{{
        getYear(now)
      }}
      u iznosu {{ totalSoldAmountWithOrganizerAdditionalFee.toFixed(2) }} EUR
    </p>
    <p>
      - U istom razdoblju vam pripada provizija za prodane ulaznice po vašem računu BROJ RAČUNA u
      iznosu {{ round(ticketPercentageFeeWithVAT, 2) }} EUR
    </p>
    <p style="border-bottom: 2px solid #979797">
      Razlika - iznos za platiti {{ round(coreEventShare, 2) }} EUR
    </p>
    <p>
      Molim Vas da iznos po obračunu {{ reportId }}/{{ getYear(new Date()) }}
      uplatite na naš račun s pozivom na broj BROJ i NEKI BROJ
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import { round } from 'lodash'
import { GET_TICKET_SELLERS_ADMIN_REPORT } from '@/graphql/order.graphql'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { exchangeRate } from '../../utils'
import { CoreEventFeeType } from '@/types'

export default {
  data() {
    return {
      orders: [],
      seller: null,
      todayDate: moment(new Date()).format('DD.MM.YYYY'),
      firstDayOfPrevMonth: moment(new Date()).subtract(1, 'month').startOf('month'),
      lastDayOfPrevMonth: moment(new Date()).subtract(1, 'month').endOf('month'),
      exchangeRate: exchangeRate,
      organizationName: null,
      totalSoldCount: 0,
      totalSoldAmountWithOrganizerAdditionalFee: 0,
      reportId: null,
      now: new Date(),
      ticketPercentageFeeWithoutVAT: null,
      ticketPercentageFeeWithVAT: 0,
      fixedTicketAdditionalFeeAmountWithoutVAT: null,
      fixedTicketAdditionalFeeAmountWithVAT: null,
      coreEventShare: null,
      organizationId: null,
      organizationFees: {},
      priceWithoutOrganizerTicketAdditionalFeeAmount: null,
    }
  },
  methods: {
    round,
    getYear(date) {
      return moment(date).year()
    },
    formatDate(date) {
      return moment(date).format('DD. MM. YYYY')
    },
  },
  apollo: {
    getTicketSellersAdminReport: {
      query: GET_TICKET_SELLERS_ADMIN_REPORT,
      variables() {
        return {
          from: this.firstDayOfPrevMonth,
          to: this.lastDayOfPrevMonth,
        }
      },
      manual: true,
      result({ data, loading }) {
        if (loading || !data.getTicketSellersAdminReport) {
          return
        }
        const { getTicketSellersAdminReport } = data
        this.organizationId = getTicketSellersAdminReport[0].organizationId
        this.organizationName = getTicketSellersAdminReport[0].organizationName
        this.organizationFees = getTicketSellersAdminReport[0].organizationFees
        this.orders = getTicketSellersAdminReport
        this.totalSoldCount = getTicketSellersAdminReport.reduce(
          (sum, order) => sum + order.count,
          0,
        )
        const totalCoreEventFeeAmountWithVat = getTicketSellersAdminReport.reduce((sum, order) => {
          let coreEventFeeWithVAT = 0
          if (
            order.fiscalisationInfo &&
            order.fiscalisationInfo.full_receipt &&
            order.fiscalisationInfo.full_receipt.items
          ) {
            const coreEventFees = order.fiscalisationInfo.full_receipt.items.filter(i =>
              i.name.includes(CoreEventFeeType.TICKET),
            )
            if (coreEventFees.length) {
              coreEventFeeWithVAT = coreEventFees.reduce((acc, curr) => acc + curr.price / 100, 0)
            }
          }

          return sum + coreEventFeeWithVAT
        }, 0)
        this.priceWithoutOrganizerTicketAdditionalFeeAmount = getTicketSellersAdminReport.reduce(
          (sum, order) => sum + order.totalPrice,
          0,
        )
        this.totalSoldAmountWithOrganizerAdditionalFee =
          this.priceWithoutOrganizerTicketAdditionalFeeAmount +
          this.totalSoldCount * ((this.organizationFees.ticketAdditionalFeeAmount || 0) * 1.25)

        this.ticketPercentageFeeWithoutVAT =
          this.priceWithoutOrganizerTicketAdditionalFeeAmount *
          (this.organizationFees.ticketPercentageFee / 100)

        this.ticketPercentageFeeWithVAT = this.ticketPercentageFeeWithoutVAT * 1.25

        this.fixedTicketAdditionalFeeAmountWithoutVAT = (
          this.totalSoldCount *
          this.organizationFees.ticketAdditionalFeeAmount *
          ((100 - this.organizationFees.coreEventAdditionalFeePercentage) / 100)
        ).toFixed(2)

        this.fixedTicketAdditionalFeeAmountWithVAT = round(
          this.fixedTicketAdditionalFeeAmountWithoutVAT * 1.25,
          2,
        )

        this.coreEventShare =
          this.totalSoldAmountWithOrganizerAdditionalFee -
          this.ticketPercentageFeeWithVAT -
          this.fixedTicketAdditionalFeeAmountWithVAT

        if (this.organizationId !== 1) {
          const halfCoreEventFeeWithVAT = totalCoreEventFeeAmountWithVat / 2
          this.coreEventShare += halfCoreEventFeeWithVAT
          this.totalSoldAmountWithOrganizerAdditionalFee += halfCoreEventFeeWithVAT
          this.ticketPercentageFeeWithVAT += halfCoreEventFeeWithVAT
        }
      },
    },
    me: {
      query: GET_LOGGED_USER,
      result({ data, loading }) {
        if (!loading && data) {
          const { me: user } = data
          this.seller = user
          this.reportId = `${user.id}${this.now.getDate()}${this.now.getMonth() + 1}${
            this.now.getHours() * 60 + this.now.getMinutes()
          }`
        }
      },
    },
  },
}
</script>

<style scoped>
#page-title {
  font-weight: 500;
  font-size: 32px;
  text-align: center;
}

.page-container {
  display: flex;
  width: 210mm;
  padding: 1.5rem;
  row-gap: 1rem !important;
}

.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid black;
}

.coreEvent-logo {
  width: 5.625rem;
  margin-bottom: 0.625rem;
}

.header-right {
  display: flex;
  flex-direction: column;
}

.header-left {
  display: flex;
  flex-direction: column;
}

.user-informations {
  border: 2px solid black;
  padding: 16px 16px 24px;
}

.user-informations-container {
  display: flex;
  justify-content: space-around;
}

.user-title {
  text-align: center;
}

.user-info-container {
  width: 48%;
}

.event-title {
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  height: 30px;
  margin-bottom: 12px;
}

.total {
  text-align: center;
  font-size: 18px;
  border-bottom: 2px solid black;
  width: 85%;
  margin: 0 auto;
}
</style>
